import { InfoCircleOutlined } from "@ant-design/icons";
import { Button, Col, Radio, Row, Select, Spin, Switch, Tooltip, message, Empty } from "antd";
import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import { loadTags } from '../redux_actions/slides.action';
import { daysInMonth, monthMapping } from "../utils/const";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {copyToClipboard, isNull, notNull, openEndPoint} from "../utils/utils";
import queryString from "query-string";
import {error_manager} from "../helper/error_manager";
import {get, post} from "../helper/request";
import { getUnauthorizedComponent } from "component/dashboard/slidelist_utils";
import { aclPermissions, hasPermissions } from "const/ACLPermissions";
import '../asset/style/add_case.css';
import '../asset/style/dashboard.css';
import { get_response } from "../helper/request";
import {isCloud} from "../utils/utils";
import {
    Autocomplete,
    Box,
    Collapse,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    FormHelperText,
    Grid,
    IconButton,
    MenuItem,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    ThemeProvider,
    Typography
} from "@mui/material";

import {DataGrid} from '@mui/x-data-grid';

const Plot = React.lazy(() => import("react-plotly.js"));

const {Option} = Select;


const sortableHeaders = [
    {
        id: 'name',
        field: 'name',
        headerName: 'Name',
        flex: 2
    },
    {
        id: 'status',
        field: 'status',
        headerName: 'Status',
        flex: 2
    },
    {
        id: 'area',
        field: 'area',
        headerName: 'Area',
        flex: 1
    },
    {
        id: 'x_tilt',
        field: 'x_tilt',
        headerName: 'X Tilt',
        flex: 1
    },
    {
        id: 'y_tilt',
        field: 'y_tilt',
        headerName: 'Y tilt',
        flex: 1
    },
    {
        id: 'export',
        field: 'export',
        headerName: 'Export',
        flex: 2
    },
    {
        id: 'upload',
        field: 'upload',
        headerName: 'Upload',
        flex: 1
    },
    {
        id: 'speed',
        field: 'speed',
        headerName: 'Speed',
        flex: 1
    },
    {
        id: 'specimen',
        field: 'specimen',
        headerName: 'Specimen Type',
        flex: 1
    },
    {
        id: 'time',
        field: 'time',
        headerName: 'Time',
        flex: 2,
        renderCell: (params) => <Grid container direction="column">
            {Object.entries(params.row['time']).map(([key, value]) => (
                key === "total_time" && typeof value === "string" ?
                    <Grid item><strong>{key}:</strong> {value}</Grid> : key === "total_time" ?
                        <Grid item><strong>{key}:</strong> {Math.round((value + Number.EPSILON) * 100) / 100}</Grid> :
                        <Grid item>{key}: {Math.round((value + Number.EPSILON) * 100) / 100}</Grid>
            ))}
        </Grid>
    },
    {
        id: 'size',
        field: 'size',
        headerName: 'Size',
        flex: 3,
        renderCell: (params) => <Grid container direction="column">
            {Object.entries(params.row['size']).map(([key, value]) => (
                <Grid item><strong>{key}:</strong> {value}</Grid>
            ))}
        </Grid>
    },
    {
        id: 'stitched',
        field: 'stitched',
        headerName: 'Stitched Info',
        flex: 2,
        renderCell: (params) => <Grid container direction="column">
            <Grid item>Stitched xMax: {params.row['stitched_x_max']}</Grid><Divider/>
            <Grid item>Stitched yMax: {params.row['stitched_y_max']}</Grid><Divider/>
            <Grid item>Stitched tileWidth: {params.row['stitched_tile_width']}</Grid><Divider/>
            <Grid item>Stitched tileHeight: {params.row['stitched_tile_height']}</Grid>
        </Grid>
    },
]

let scanColumns = [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: 'Time',
        dataIndex: 'time',
        key: 'time',
    },
    {
        title: 'Area',
        dataIndex: 'area',
        key: 'area',
    },
    {
        title: 'Slide Tilt',
        dataIndex: 'tilt',
        key: 'tilt',
    },
];


class StatsDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            selectedYear: new Date().getFullYear(),
            currentYear: new Date().getFullYear(),
            currentMonth: new Date().getMonth(),
            selectedMonth: new Date().getMonth(),
            selectedDate: 32,
            fullStatsData: {},
            selectedTags: [],
            showDate: true,
            displayText: "",
            isAnalysis: false,
            analysisKeys: [],
            analysisData: {},
            selectedKeys: [],
            scanData: {},
            tagsScanData: {},
            summaryData: {},
            openAnchor: null,
            openDialog: null,
            isDataFetched: false,
            analysisCurrentDataPoints:0
        };
    }

    
    componentDidMount = () => {
        this.props.dispatch(loadTags());
    }

    getAnalysisDataForTags = () => {
        this.setState({
            isFetching: true,
        });
        let {selectedYear, selectedMonth, selectedDate, isAnalysis, showDate, selectedTags} = this.state;

        let params = "tags="
        selectedTags.map((tag) => params += tag.replace('#', '%23') + '%2c')
        
        let url = '/api/stats/get_analysis_data_for_tags/?' + params;
        get_response(url)
            .then(response => {
                let displayText;
                this.setState({
                    isFetching: false,
                });
                    this.setState({
                        analysisKeys: response.data['keys'],
                        analysisData: response.data['analysis'],
                    })
                
            })
            .catch(() => {
                message.error("Failed to get stats. Contact Admin");
                this.setState({
                    isFetching: false,
                });
            });
    }

    getAnalysisData = () => {
        this.setState({
            isFetching: true,
        });
        let {selectedYear, selectedMonth, selectedDate, isAnalysis, showDate, selectedTags} = this.state;

        let params = "year=" + selectedYear + '&month=' + (selectedMonth + 1) + '&date=' + selectedDate + '&isAnalysis=' + isAnalysis;
        if (!showDate) {
            this.setState({isAnalysis: false})
            params = "tags="
            selectedTags.map((tag) => params += tag.replace('#', '%23') + '%2c')
        }
        let url = '/api/stats/get_analysis_data/?' + params;
        get_response(url)
            .then(response => {
                let displayText;
                this.setState({
                    isFetching: false,
                });
                if(!response.data['keys'] || response.data['keys'].length===0){
                    message.warn("No Analysis Data found!")
                }
                    this.setState({
                        analysisKeys: response.data['keys'],
                        analysisData: response.data['analysis'],
                    })
                
            })
            .catch(() => {
                message.error("Failed to get stats. Contact Admin");
                this.setState({
                    isFetching: false,
                });
            });
    }


    handleChangeYear = (value) => {
        this.setState({
            selectedYear: value,
        }, this.checkDatesState);
    }

    getYearOptions = () => {
        let yearOptions = [];
        for (let i = 2018; i <= new Date().getFullYear(); i++) {
            yearOptions.push(
                <Option value={i}>{i}</Option>
            )
        }
        return yearOptions;
    }

    handleChangeMonth = (value) => {
        
        this.setState({
            selectedMonth: value,
        }, this.checkDatesState);
    }

    getMonthOptions = () => {
        let monthOptions = [];
        monthOptions.push(
            <Option value={12}>{monthMapping[13]}</Option>
        )
        if (this.state.selectedYear !== undefined && (this.state.currentYear !== this.state.selectedYear)) {
            for (let i = 1; i <= 13; i++) {
                monthOptions.push(
                    <Option value={i - 1}>{monthMapping[i]}</Option>
                )
            }
            return monthOptions;
        }
        for (let i = 1; i <= new Date().getMonth() + 1; i++) {
            monthOptions.push(
                <Option value={i - 1}>{monthMapping[i]}</Option>
            )
        }
        return monthOptions;
    }

    handleChangeDate = (value) => {
        this.setState({
            selectedDate: value,
        }, this.checkDatesState);
    }

    getDateOptions = () => {
        let dateOptions = [];
        let totalDate;
        dateOptions.push(
            <Option value={32}>{"Total"}</Option>
        )
        if ((this.state.selectedYear !== undefined && (this.state.currentYear !== this.state.selectedYear)) || 
            (this.state.selectedMonth !== undefined && (this.state.currentMonth !== this.state.selectedMonth))) {
                totalDate = daysInMonth[this.state.selectedMonth];
                if (this.state.selectedMonth === 1) { // February
                    // Check for leap year
                    if ((this.state.selectedYear % 4 === 0 && this.state.selectedYear % 100 !== 0) || this.state.selectedYear % 400 === 0) {
                        totalDate = 29; // Leap year
                    }
                }
        }
        else{
            totalDate = new Date().getDate();
        }
        for (let i = 1; i <= totalDate; i++) {
            dateOptions.push(
                <Option value={i}>{i}</Option>
            )
        }
        return dateOptions;
    }

    handleScanAnalysis = (isAnalysis) => {
        this.setState({isAnalysis: isAnalysis});
        if(this.state.selectedMonth === 12) {
            message.warn("Choose a month to get analysis plot")
            this.setState({
                isAnalysis:false
            })
            return
        }
        if(!this.state.isDataFetched){
            return
        }
        if(isAnalysis){
            this.getAnalysisData()
        }
        
    };

    handleScanAnalysisForTags = (isAnalysis) => {
        this.setState({isAnalysis: isAnalysis});
        if(!this.state.isDataFetched){
            return  
        }
        if(isAnalysis){
            this.getAnalysisDataForTags()
        }
        
    };

    handleKeysChange = (selectedKeys) => {
        if (selectedKeys.length <= 5) {
            this.setState({selectedKeys: selectedKeys});
        } else {
            message.info("Can't select more than 5 Keys")
        }
    };

    getKeysOptions = () => {
        const options = [];
        this.state.analysisKeys.map(data => (
            options.push(<Option value={data}>{data}</Option>)
        ))
        return options;
    }

    getScansStatForTable = () => {
        let statData = [];
        for (const key in this.state.fullStatsData) {
            let totalData = {};
            if (this.state.fullStatsData[key]["scans"]["total"] > 0) {
                totalData = {
                    key: key,
                    'Date': this.getDateAndPlotComponent(this.state.fullStatsData[key]['name']),
                    'totalScans': this.getScanSizeComponent(this.state.fullStatsData[key]),
                    'timeComponent': this.getTimeComponent(this.state.fullStatsData[key]),
                    'sizeComponent': this.getSizeComponent(this.state.fullStatsData[key]),
                    // 'graphComponent': this.getPlotComponent(j),
                    'scannedAreaComponent': this.getScannedAreaComponent(this.state.fullStatsData[key]),
                    'scanSpeedComponent': this.getScanSpeedComponent(this.state.fullStatsData[key]),
                    'scanStreaksComponent': this.getScanStreaksComponent(this.state.fullStatsData[key]),
                    'specimenTypeComponent': this.getSpecimenTypeComponent(this.state.fullStatsData[key]),
                    'plot': this.getPlot(this.state.fullStatsData[key])
                }
            } else{
                totalData = {
                    key: key,
                    'Date': this.getDateAndPlotComponent(this.state.fullStatsData[key]['name']),
                    'totalScans': null,
                    'timeComponent': null,
                    'sizeComponent': <b>{"No Scans"}</b>,
                    // 'graphComponent': this.getPlotComponent(j),
                    'scannedAreaComponent': null,
                    'scanSpeedComponent': null,
                    'specimenTypeComponent': null,
                }
            }
            statData.push(totalData);
        }
        return statData;
    }

    getScanWiseData = (scans_data) => {
        if (scans_data) {
            let final_data = [];
            for(const scan in scans_data){
                let scan_data = {
                    key: this.getMorphleId(scans_data[scan]),
                    name: this.getScanName(scans_data[scan]),
                    time: this.getScanTime(scans_data[scan]),
                    area: this.getScanArea(scans_data[scan]),
                    tilt: this.getScanTilt(scans_data[scan])
                }
                final_data.push(scan_data);
            }
            return final_data;
        }
    }

    getPlot = (data) => {
        let scanAnalysisData = {};
        if (this.state.isAnalysis && this.state.analysisData) {
            scanAnalysisData = Object.keys(this.state.analysisData).find(key => key === data.name) && this.state.analysisData[data.name]['scan_analysis'];
        }
        let scanWiseStat = this.getScanWiseData(data['scan_wise_data'])
        return <>
            <Suspense fallback={<div>Loading...</div>}>
                <Plot
                    data={[
                        {
                            "x": data['x_um_per_mm'],
                            "type": "histogram",
                            autobinx: false,
                            xbins: {
                            size: 0.2,
                            start: 0
                        }
                    }
            ]}
            layout = {{
                bargap: 0.05, 
                bargroupgap: 0.2,
                title: "X Tilt", 
                xaxis: {title: "x_um_per_mm"}, 
                yaxis: {title: "Count"}
            }}
            />
            <Plot
                data={[
                    {
                        "x": data['y_um_per_mm'],
                        "type": "histogram",
                        autobinx: false,
                        xbins: {
                            size: 0.2,
                            start: 0
                        }
                    }
            ]}
            layout = {{
                bargap: 0.05, 
                bargroupgap: 0.2,
                title: "Y Tilt", 
                xaxis: {title: "y_um_per_mm"}, 
                yaxis: {title: "Count"}
            }}
            />
            <Plot
                data={[
                    {
                        "x": data['area'],
                        "y": data['time'],
                        'name': "AreaAndTime",
                        "type": "scatter",
                        "mode": "markers+text"
                    },
                    {
                        // x: tilt, y: num_scans
                    }
            ]}
                layout={{
                    height: 540,
                    title: 'Area v/s Time',
                    xaxis: {
                        title: {
                            text: 'Area',
                            font: {
                                family: 'Courier New, monospace',
                                size: 18,
                                color: '#7f7f7f'
                            }
                        }
                    },
                    yaxis: {
                        title: {
                            text: 'Time',
                            font: {
                                family: 'Courier New, monospace',
                                size: 18,
                                color: '#7f7f7f'
                            }
                        }
                    }
                }}
            />
            <Plot
                data={[
                    {
                        "x": data['avg_compensation_time'],
                        "type": "histogram",
                        autobinx: false,
                        xbins: {
                            size: 10.0,
                            start: 0
                        }
                    }
            ]}
            layout = {{
                bargap: 0.05, 
                bargroupgap: 0.2,
                title: "Avg Compensation Time", 
                xaxis: {title: ""}, 
                yaxis: {title: "Count"}
            }}
            />
            <Plot
                data={[
                    {
                        "x": data['avg_pullback_for_streak_time'],
                        "type": "histogram",
                        autobinx: false,
                        xbins: {
                            size: 10.0,
                            start: 0
                        }
                    }
                ]}
                layout={{
                    bargap: 0.05,
                    bargroupgap: 0.2,
                    title: "Avg Pullback Time",
                    xaxis: {title: ""},
                    yaxis: {title: "Count"}
                }}
            />
                {this.state.isAnalysis && <Plot id={'plot'}
                                                data={this.getAnalysisPlot(scanAnalysisData)}
                                                layout={{
                                                    title: "Scan Analysis Plot",
                                                    xaxis: {title: ""},
                                                    yaxis: {title: "Analysis Keys"}
                                                }}
                />}
            </Suspense>
            <Table
                dataSource={scanWiseStat}
                columns={scanColumns}
                pagination={true}
            />
        </>
    }

    getAnalysisPlot = (data) => {
        let final = [];
        if(!data || !Array.isArray(data)) return final;
        const colors = ['#FF4500', '#32CD32', '#66CDAA', '#FF1493', '#9400D3']
        let count = 0

        this.state.selectedKeys.forEach((key, idx) => {
            let x = [], y = [], color = [];

            data.forEach((val, index) => {
                Object.entries(val).forEach(([k, v]) => {
                    if (k === key) {
                        x.push(index + 1);
                        y.push(v);
                        color.push(colors[idx])
                    }
                })
            })
            count+=Math.max(x.length, y.length, color.length)
            
            final.push({
                type: 'scatter',
                mode: 'markers',
                x: x,
                y: y,
                name: key,
                marker: {color: color, size: 10},
            })
        })
        if(this.state.analysisCurrentDataPoints!==count){
            this.setState({analysisCurrentDataPoints: count})
        }
        
        return final;
    }

    getDateAndPlotComponent = (date) => {
        return <Tooltip title={"Click on '+' Button to Plot Area vs Time"} placement={"right"}>
            <b>
                {date}
            </b>
        </Tooltip>
    }

    getTimeComponent = (monthData) => {
      let meanMinutes = Math.floor(monthData.mean_time);
      let medianMinutes = Math.floor(monthData.median_time);
      let sumMinutes = Math.floor(monthData.sum_time);
        return <div>
            <Row>
                <Col span={8}>
                    <span>{"Mean: "}</span>
                </Col>
                <Col span={16}>
                    <span>{meanMinutes + " min. " + Math.floor((monthData.mean_time-meanMinutes) * 60) + " sec."}</span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Median: "}</span>
                </Col>
                <Col span={16}>
                    <span>{medianMinutes + " min. " + Math.floor((monthData.median_time - medianMinutes) * 60) + " sec."}</span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Sum: "}</span>
                </Col>
                <Col span={16}>
                    <span>{sumMinutes + " min. " + Math.floor((monthData.sum_time-sumMinutes) * 60) + " sec."}</span>
                </Col>
            </Row>
			{monthData.missing_slide_meta > 0 ?
            <Row>
                <b>{monthData.missing_slide_meta} missing</b>
            </Row> : null}
        </div>
    }

    getSizeComponent = (monthData) => {
        return <div>
            <Row>
                <b>{"Total Size"}</b>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Mean: "}</span>
                </Col>
                <Col span={16}>
                    <span>{(monthData.mean_total_size / 1024 / 1024 / 1024) < 1 ? (monthData.mean_total_size / 1024 / 1024).toFixed(2) + " MB" :
                        (monthData.mean_total_size / 1024 / 1024 / 1024).toFixed(2) + " GB"}
                    </span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Median: "}</span>
                </Col>
                <Col span={16}>
                    <span>{(monthData.median_total_size / 1024 / 1024 / 1024) < 1 ? (monthData.median_total_size / 1024 / 1024).toFixed(2) + " MB" :
                        (monthData.median_total_size / 1024 / 1024 / 1024).toFixed(2) + " GB"}
                    </span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Sum: "}</span>
                </Col>
                <Col span={16}>
                    <span>{(monthData.sum_total_size / 1024 / 1024 / 1024) < 1 ? (monthData.sum_total_size / 1024 / 1024).toFixed(2) + " MB" :
                        (monthData.sum_total_size / 1024 / 1024 / 1024).toFixed(2) + " GB"}
                    </span>
                </Col>
            </Row>
            <Row>
                <b>{"Required Size"}</b>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Mean: "}</span>
                </Col>
                <Col span={16}>
                    <span>{(monthData.mean_required_size / 1024 / 1024 / 1024) < 1 ? (monthData.mean_required_size / 1024 / 1024).toFixed(2) + " MB" :
                        (monthData.mean_required_size / 1024 / 1024 / 1024).toFixed(2) + " GB"}
                    </span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Median: "}</span>
                </Col>
                <Col span={16}>
                    <span>{(monthData.median_required_size / 1024 / 1024 / 1024) < 1 ? (monthData.median_required_size / 1024 / 1024).toFixed(2) + " MB" :
                        (monthData.median_required_size / 1024 / 1024 / 1024).toFixed(2) + " GB"}
                    </span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Sum: "}</span>
                </Col>
                <Col span={16}>
                    <span>{(monthData.sum_required_size / 1024 / 1024 / 1024) < 1 ? (monthData.sum_required_size / 1024 / 1024).toFixed(2) + " MB" :
                        (monthData.sum_required_size / 1024 / 1024 / 1024).toFixed(2) + " GB"}
                    </span>
                </Col>
            </Row>
            <Row>
                <b>{"Debug Size"}</b>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Mean: "}</span>
                </Col>
                <Col span={16}>
                    <span>{(monthData.mean_debug_size / 1024 / 1024 / 1024) < 1 ? (monthData.mean_debug_size / 1024 / 1024).toFixed(2) + " MB" :
                        (monthData.mean_debug_size / 1024 / 1024 / 1024).toFixed(2) + " GB"}
                    </span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Median: "}</span>
                </Col>
                <Col span={16}>
                    <span>{(monthData.median_debug_size / 1024 / 1024 / 1024) < 1 ? (monthData.median_debug_size / 1024 / 1024).toFixed(2) + " MB" :
                        (monthData.median_debug_size / 1024 / 1024 / 1024).toFixed(2) + " GB"}
                    </span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Sum: "}</span>
                </Col>
                <Col span={16}>
                    <span>{(monthData.sum_debug_size / 1024 / 1024 / 1024) < 1 ? (monthData.sum_debug_size / 1024 / 1024).toFixed(2) + " MB" :
                        (monthData.sum_debug_size / 1024 / 1024 / 1024).toFixed(2) + " GB"}
                    </span>
                </Col>
            </Row>
			{monthData.missing_slide_meta > 0 ?
            <Row>
                <b>{monthData.missing_slide_meta} missing</b>
            </Row> : null}
        </div>
    }

    getScanSizeComponent = (monthData) => {
        return <div>
            <Row>
                <Col span={14}>
                    <Tooltip
                        title="Counts Scans that are Successful or Failed"><InfoCircleOutlined/></Tooltip><span><b>{" Total: "}</b></span>
                </Col>
                <Col span={8}>
                    <span>{monthData.scans['total']}</span>
                </Col>
            </Row>
            <Divider/>
            <Row>
                <Col span={14}>
                    <Tooltip
                        title="Counts Scans that are Successfully Completed and contributes to the Remaining Metrics"><InfoCircleOutlined/></Tooltip><span><b>{" Success: "}</b></span>
                </Col>
                <Col span={8}>
                    <span>{monthData.scans['success']}
                    </span>
                </Col>
            </Row>
            <Divider/>
            <Row>
                <Col span={14}>
                    <Tooltip
                        title="Counts Scans that are Failed and Distributes them into Cancelled, Errored Out or in Progress"><InfoCircleOutlined/></Tooltip><span><b>{" Failed: "}</b></span>
                </Col>
                <Col span={8}>
                    <span>{monthData.scans['failed']}
                    </span>
                </Col>
            </Row>
            <Row>
                <Col span={14}>
                    <span>{"Errored: "}</span>
                </Col>
                <Col span={8}>
                    <span>{monthData.scans['errored']}</span>
                </Col>
            </Row>
            <Row>
                <Col span={14}>
                    <span>{"Cancelled: "}</span>
                </Col>
                <Col span={8}>
                    <span>{monthData.scans['cancelled']}</span>
                </Col>
            </Row>
            <Row>
                <Col span={14}>
                    <span>{"In Progress: "}</span>
                </Col>
                <Col span={8}>
                    <span>{monthData.scans['In_progress']}</span>
                </Col>
            </Row>
            <Divider/>
            <Row>
                <Col span={14}>
                    <Tooltip
                        title="Counts Scans that are Uploaded Successfully"><InfoCircleOutlined/></Tooltip><span><b>{" Uploaded: "}</b></span>
                </Col>
                <Col span={8}>
                    <span>{monthData.scans['uploaded']}</span>
                </Col>
            </Row>
            <Divider/>
			{monthData.missing_slide_meta > 0 ?
            <Row>
                <b>{monthData.missing_slide_meta + " missing"}</b>
            </Row> : null}
        </div>
    }

    getScanStreaksComponent = (monthData) => {
        return <div>
            <Row>
                <b>{"Streak Pullback Time"}</b>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Mean: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.mean_avg_pullback_for_streak_time.toFixed(2) + " ms"}</span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Median: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.median_avg_pullback_for_streak_time.toFixed(2) + " ms"}</span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Max: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.max_avg_pullback_for_streak_time.toFixed(4) + " ms"}</span>
                </Col>
            </Row>
			{monthData.missing_pullback_for_streak_data > 0 ?
            <Row>
                <b>{monthData.missing_pullback_for_streak_data + " missing"}</b>
            </Row> : null}
            <Divider/>
            <Row>
                <b>{"Avg Compensation Time"}</b>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Mean: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.mean_avg_compensation_time.toFixed(2) + " ms"}</span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Median: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.median_avg_compensation_time.toFixed(2) + " ms"}</span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Max: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.max_avg_compensation_time.toFixed(4) + " ms"}</span>
                </Col>
            </Row>
			{monthData.missing_avg_compensation_time_data > 0 ?
            <Row>
                <b>{monthData.missing_avg_compensation_time_data + " missing"}</b>
            </Row> : null}
            <Divider/>
            <Row>
                <b>{"Streak Count"}</b>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Mean: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.mean_streak_count.toFixed(2)}</span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Median: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.median_streak_count.toFixed(2)}</span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Max: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.max_streak_count.toFixed(4)}</span>
                </Col>
            </Row>
			{monthData.missing_streak_data > 0 ?
            <Row>
                <b>{monthData.missing_streak_data + " missing"}</b>
            </Row> : null}
            <Divider/>
            <Row>
                <b>{"Streak Translation Time"}</b>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Mean: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.mean_avg_streak_time.toFixed(2) + " ms"}</span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Median: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.median_avg_streak_time.toFixed(2) + " ms"}</span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Max: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.max_avg_streak_time.toFixed(4) + " ms"}</span>
                </Col>
            </Row>
        </div>
    }

    getScannedAreaComponent = (monthData) => {
        return <div>
            <Row>
                <b>{"Scan Area"}</b>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Mean: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.mean_area.toFixed(2) + " mm2"}</span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Median: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.median_area.toFixed(2) + " mm2"}</span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Sum: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.sum_area.toFixed(2) + " mm2"}</span>
                </Col>
            </Row>
			{monthData.missing_slide_meta > 0 ?
            <Row>
                <b>{monthData.missing_slide_meta + " missing"}</b>
            </Row> : null}
            <Divider/>
            <Row>
                <b>{"X Tilt"}</b>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Mean: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.mean_x_tilt.toFixed(4)+" u/mm"}</span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Median: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.median_x_tilt.toFixed(4)+" u/mm"}</span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Max: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.max_x_tilt.toFixed(4)+" u/mm"}</span>
                </Col>
            </Row>
            <Row>
                <b>{"Y Tilt"}</b>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Mean: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.mean_y_tilt.toFixed(4)+" u/mm"}</span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Median: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.median_y_tilt.toFixed(4)+" u/mm"}</span>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <span>{"Max: "}</span>
                </Col>
                <Col span={16}>
                    <span>{monthData.max_y_tilt.toFixed(4)+" u/mm"}</span>
                </Col>
            </Row>
			{monthData.missing_tilt > 0 ?
            <Row>
                <b>{monthData.missing_tilt + " missing"}</b>
            </Row> : null}
        </div>
    }

    getScanSpeedComponent = (monthData) => {
        let scanSpeedRows = [];
        let keys = Object.keys(monthData.scan_speed);
        for (let i = 0; i < keys.length; i++) {
            scanSpeedRows.push(
                <Row>
                    <Col span={12}>
                        <span>{keys[i] + ": "}</span>
                    </Col>
                    <Col span={12}>
                        <span>{monthData.scan_speed[keys[i]]}</span>
                    </Col>
                </Row>
            );
        }
        return <div>
            {scanSpeedRows}
			{monthData.missing_scan_speed > 0 ?
            <Row>
                <b>{monthData.missing_scan_speed + " missing"}</b>
            </Row> : null}
        </div>
    }

    getSpecimenTypeComponent = (monthData) => {
        let scanSpeedRows = [];
        let keys = Object.keys(monthData.specimen_type);
        for (let i = 0; i < keys.length; i++) {
            scanSpeedRows.push(
                <Row>
                    <Col span={12}>
                        <span>{keys[i] + ": "}</span>
                    </Col>
                    <Col span={12}>
                        <span>{monthData.specimen_type[keys[i]]}</span>
                    </Col>
                </Row>
            );
        }
        return <div>
            {scanSpeedRows}
            {/* <Row>
                <b>{monthData.missing_objective_type + " missing"}</b>
            </Row> */}
        </div>
    }

    getScanName(scan) {
        return <b>{scan.name}</b>;
    }

    getMorphleId(scan) {
        return <b>{scan.morphle_id}</b>;
    }

    getScanArea(scan) {
        return <b>{scan.area}</b>;
    }

    getScanTime(scan) {
      let time = Math.floor(scan.time);
        return <b>{time + " min. " + Math.floor((scan.time - time) * 60) + " sec."}</b>;
    }
    
    getScanTilt(scan) {
        return <div>
            <Row>
                <Col span={4}>
                    <span>{"X Tilt: "}</span>
                </Col>
                <Col span={8}>
                    <span>{scan.tilt.x_tilt.toFixed(4) + " u/mm"}</span>
                </Col>
            </Row>
            <Row>
                <Col span={4}>
                    <span>{"Y Tilt: "}</span>
                </Col>
                <Col span={8}>
                    <span>{scan.tilt.y_tilt.toFixed(4) + " u/mm"}</span>
                </Col>
            </Row>
            </div>;
    }

    checkDatesState = () => {
        const year = this.state.selectedYear
        const month = parseInt(this.state.selectedMonth)
        const date = this.state.selectedDate
        
        var inputDate = new Date(year, month, date); // Note: month is zero-based
        if(date=='32'){
            return
        }
        // Create a Date object for today's date
        var currentDate = new Date();
        // Check if the input date is a valid date
        if (isNaN(inputDate.getTime())) {
            message.warn("Invalid Date")
            return false; // Invalid date
        }

        // Check if the input date is less than or equal to today's date
        if (inputDate > currentDate) {
            message.warn("You have selected a future date. Please choose a valid date", 5)
            return; // Future date
        }

        return true; 
    }

    // functions from scan anaysis component

    getTotalYearlyScansInfo = (monthsData) => {
        let scansTotal = 0, scansExported = 0, scansSuccess = 0, scansErrored = 0, scansInProgress = 0,
            scansCancelled = 0, necessarySize = 0, totalSize = 0, debugSize = 0;
        let scansFast = 0, scansMedium = 0, scansSlow = 0, scansZstack = 0;
        let scansHne = 0, scansPap = 0, scansIhc = 0, totalScanTime = 0;
        const scansOnMonths = [];
        let month = this.state.selectedYear === new Date().getFullYear() ? new Date().getMonth() + 1 : 12;
        for (let i = 0; i < month; i++) {
            scansOnMonths[i] = {id: i + 1}
        }
        Object.values(monthsData).forEach((data, index) => {
            scansTotal += data['summarized_scan_count']['total'];
            scansExported += data['summarized_scan_count']['exported'];
            scansSuccess += data['summarized_scan_count']['success'];
            scansErrored += data['summarized_scan_count']['failed']['errored'];
            scansInProgress += data['summarized_scan_count']['failed']['In_progress'];
            scansCancelled += data['summarized_scan_count']['failed']['cancelled'];
            scansFast += data['summarized_scan_speed']['FAST'];
            scansMedium += data['summarized_scan_speed']['MEDIUM'];
            scansSlow += data['summarized_scan_speed']['SLOW'];
            scansZstack += data['summarized_scan_speed']['ZSTACK'];
            scansHne += data['summarized_specimen_type']['HNE'];
            scansIhc += data['summarized_specimen_type']['IHC'];
            scansPap += data['summarized_specimen_type']['PAP'];
            necessarySize += this.reverseSizeFmt(data['size']['necessary_size_on_hdd'])
            totalSize += this.reverseSizeFmt(data['size']['total_size_on_hdd'])
            debugSize += this.reverseSizeFmt(data['size']['debug_size_on_hdd'])

            let sumTotalScanTime = data['sum_total_scan_time'];
            try {
                if (sumTotalScanTime.split(" ")[1] === "Hours")
                    totalScanTime += parseFloat(sumTotalScanTime.split(" ")[0]) * 60;
                else
                    totalScanTime += parseFloat(sumTotalScanTime.split(" ")[0]);
            } catch (e) {
                totalScanTime += parseFloat(sumTotalScanTime.toString());
            }
            scansOnMonths.forEach(object => {
                if (object.id === parseFloat(data['month'].split("/")[1])) {
                    object['total'] = data['summarized_scan_count']['total'];
                }
            });
        })
        const scansCount = {
            "success": scansSuccess,
            "total": scansTotal,
            "failed": {
                "errored": scansErrored,
                "cancelled": scansCancelled,
                "In_progress": scansInProgress,
                "total": scansTotal - scansSuccess,
            },
            "exported": scansExported,
        }
        const scansSpeed = {
            "FAST": scansFast,
            "MEDIUM": scansMedium,
            "SLOW": scansSlow,
            "ZSTACK": scansZstack
        }
        const scansSpecimen = {
            "HNE": scansHne,
            "IHC": scansIhc,
            "PAP": scansPap,
        }
        const scanSize = {
            "Necessary_size_on_hdd" : this.outputSizeFmt(necessarySize),
            "Total_size_on_hdd" : this.outputSizeFmt(totalSize),
            "Debug_size_on_hdd" : this.outputSizeFmt(debugSize)
        }
        const avgScanTime = totalScanTime / scansSuccess;
        return <>
            <TableRow key={-1}
                      sx={{":hover": {backgroundColor: 'rgb(203, 195, 227, 0.4)'}}}>
                <TableCell>
                    <IconButton
                        aria-label="expand row" size="small"
                        onClick={() => this.handleDropdownClose(-2)}>
                        {this.state.openAnchor === -2 ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row"><strong>Total: </strong>{this.state.selectedYear}
                </TableCell>
                <TableCell>{this.getScanCount(scansCount)}</TableCell>
                <TableCell align="right">{this.getScanSpeed(scansSpeed)}</TableCell>
                <TableCell align="right">{this.getSpecimenType(scansSpecimen)}</TableCell>
                <TableCell align="right">{this.getScanSize(scanSize)}</TableCell>
                <TableCell align="right">-</TableCell>
                <TableCell align="right">
                    <strong>Average Scan Time:</strong><br/>
                    {`${Math.round((avgScanTime + Number.EPSILON) * 100) / 100} min`}<br/>
                    <strong>Total Scan Time:</strong>{`${Math.round((totalScanTime + Number.EPSILON) * 100) / 100} min`}
                </TableCell>
                
            </TableRow>
            <TableRow>
                <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={6}>
                    <Collapse in={this.state.openAnchor === -2} timeout="auto" unmountOnExit>
                        <Box sx={{margin: 1}}>
                            <Typography variant="h6" gutterBottom component="div">
                                Summary Info
                            </Typography>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Scans Count Date-Wise</TableCell>
                                        <TableCell align="left">Plot</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow key={'-1'} sx={{":hover": {backgroundColor: 'rgb(203, 195, 227, 0.2)'}}}>
                                        <TableCell component="th" scope="row">
                                            {this.scansOnMonth(scansOnMonths)}
                                        </TableCell>
                                        <TableCell align="left">{this.getPlot(scansOnMonths, true)}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    }

    getSummaryInfo = (val) => {
        if (isNull(val)) return;
        return <TableRow key={val['month']} sx={{":hover": {backgroundColor: 'rgb(203, 195, 227, 0.2)'}}}>
            <TableCell component="th" scope="row">
                {this.scansOnDate(val['scans_on_dates'])}
            </TableCell>
            <TableCell align="left">{val['last_updated_readable']}</TableCell>
            <TableCell align="left">{this.getPlot(val['scans_on_dates'], false)}</TableCell>
        </TableRow>
    }

    getScanInfo = (val) => {
        if (isNull(val)) return;
        return Object.values(val).map((scanInfo, index) => {
            let scanArea = scanInfo['area'] || 0;
            return (
                {
                    id: index + 1,
                    name: scanInfo['name'],
                    status: scanInfo['status'],
                    area: Math.round((parseFloat(scanArea.toString()) + Number.EPSILON) * 100) / 100,
                    x_tilt: scanInfo['x_um_per_mm'] || 0,
                    y_tilt: scanInfo['y_um_per_mm'] || 0,
                    export: scanInfo['export_status'] ,
                    upload: scanInfo['upload_status'],
                    speed: scanInfo['scan_speed'],
                    specimen: scanInfo['specimen_type'],
                    time: scanInfo['time'],
                    size: scanInfo['size'],
                    stitched_x_max: scanInfo['stitched_x_max'],
                    stitched_y_max: scanInfo['stitched_y_max'],
                    stitched_tile_height: scanInfo['stitched_tile_height'],
                    stitched_tile_width: scanInfo['stitched_tile_width'],
                }
            );
        })
    }

    getAverageScanTime = (scanTime, successScans) => {
        let avgScanTime;
        try {
            if (scanTime.split(" ")[1] === "Hours")
                avgScanTime = (parseFloat(scanTime.split(" ")[0]) * 60) / successScans;
            else
                avgScanTime = parseFloat(scanTime.split(" ")[0]) / successScans;
        } catch (e) {
            avgScanTime = parseFloat(scanTime) / successScans;
        }
        return `${Math.round((avgScanTime + Number.EPSILON) * 100) / 100} min`;
    }

    getPlot = (data, isYear) => {
        if (isNull(data)) return;
        let plotData;
        if (isYear) {
            let x = [], y = [];
            Object.values(data).forEach((i, index) => {
                x[index] = monthMapping[i.id];
                y[index] = i.total ? i.total : 0;
            });
            plotData = {
                x: x, y: y,
                type: "scatter",
                mode: "lines+markers",
                marker: {color: "red"},
                name: "Date v/s Total Scans"
            }
        } else {
            let sortedScanDates = Object.keys(data).sort().reduce((scanDates, key) => {
                scanDates[key] = data[key];
                return scanDates;
            }, {});
            plotData = {
                x: Object.keys(sortedScanDates),
                y: Object.values(sortedScanDates),
                type: "scatter",
                mode: "lines+markers",
                marker: {color: "red"},
                name: "Date v/s Total Scans"
            }
        }
        return <Suspense fallback={<div>Loading...</div>}><Plot data={[plotData]}/></Suspense>
    }

    getScanCount = (val) => {
        if (isNull(val)) return;
        return <Grid container direction="column">
            {
                Object.keys(val).map((key) => {
                    let value = val[key];
                    if (key === "failed") {
                        return (<><Grid item><strong>{key[0].toUpperCase() + key.slice(1)}:</strong></Grid><Divider/>
                            {Object.keys(value).map((f_key) => {
                                return <Grid item>{f_key[0].toUpperCase() + f_key.slice(1)}: {value[f_key]}</Grid>
                            })
                            }
                            <Divider/>
                        </>)
                    }
                    return <><Grid item><strong>{key[0].toUpperCase() + key.slice(1)}:</strong> {value}
                    </Grid><Divider/></>
                })
            }
        </Grid>
    }


    getScanSpeed = (val) => {
        if (isNull(val)) return;
        return <Grid container direction="column">
            {Object.keys(val).map((key) => {
                    return <Grid item>{key.toUpperCase()}: {val[key]}</Grid>
                })
            }
        </Grid>
    }

    getSpecimenType = (val) => {
        if (isNull(val)) return;
        return <Grid container direction="column">
        {Object.keys(val).map((key) => {
                return <Grid item>{key.toUpperCase()}: {val[key]}</Grid>
            })
        }
        </Grid>
    }

    getScanSize = (val) => {
        if (isNull(val)) return;
        return <Grid container direction="column">
            {
                Object.keys(val).map((key) => {
                    let value = val[key];
                    if (key === "failed") {
                        return (<><Grid item><strong>{key[0].toUpperCase() + key.slice(1)}:</strong></Grid><Divider/>
                            {Object.keys(value).map((f_key) => {
                                return <Grid item>{f_key[0].toUpperCase() + f_key.slice(1)}: {value[f_key]}</Grid>
                            })
                            }
                            <Divider/>
                        </>)
                    }
                    return <><Grid item><strong>{key[0].toUpperCase() + key.slice(1)}:</strong> {value}
                    </Grid><Divider/></>
                })
            }
        </Grid>
    }

    getScanAreaSumm = (val) => {
        if (isNull(val)) return;
        return <Grid container direction="column">
            {
                Object.keys(val).map((key) => {
                    let value = val[key];
                    if (key === "failed") {
                        return (<><Grid item><strong>{key[0].toUpperCase() + key.slice(1)}:</strong></Grid><Divider/>
                            {Object.keys(value).map((f_key) => {
                                return <Grid item>{f_key[0].toUpperCase() + f_key.slice(1)}: {value[f_key].toFixed(2)}</Grid>
                            })
                            }
                            <Divider/>
                        </>)
                    }
                    return <><Grid item><strong>{key[0].toUpperCase() + key.slice(1)}:</strong> {value.toFixed(2)}
                    </Grid><Divider/></>
                })
            }
        </Grid>
    }

    getOtherDetails = (scano, morpheus) => {
        if (isNull(scano)) return;
        return <Grid container direction="column">
            <Grid item>Scano: <strong>{scano}</strong></Grid>
            <Grid item>Morpheus: <strong>{morpheus}</strong></Grid>
        </Grid>
    }

    scansOnDate = (val) => {
        if (isNull(val)) return;
        let sortedScanDates = Object.keys(val).sort().reduce((scanDates, key) => {
            scanDates[key] = val[key];
            return scanDates;
        }, {});
        return <Grid container direction="column">
            {Object.entries(sortedScanDates).map(([date, scansCount]) => (
                <Grid item>
                    <strong>{date}</strong> : {scansCount}
                </Grid>
            ))}
        </Grid>
    }

    scansOnMonth = (val) => {
        if (isNull(val)) return;
        return <Grid container direction="column">
            {Object.values(val).map(month => (
                month.total ? <Grid item><strong>{monthMapping[month.id]}</strong> : {month.total}</Grid> :
                    <Grid item><strong>{monthMapping[month.id]}</strong> : {0}</Grid>
            ))}
        </Grid>
    }

    getPlots = (scanData, date) => {
        let x_tilt_data = []
        let y_tilt_data = []
        let time_data = []
        let area_data = []
        for (let objId in scanData) {
            if (scanData.hasOwnProperty(objId)) {
                if(scanData[objId]['x_um_per_mm'] && scanData[objId]['x_um_per_mm']!==0){
                    x_tilt_data.push(scanData[objId]['x_um_per_mm']);
                }
                if(scanData[objId]['y_um_per_mm'] && scanData[objId]['y_um_per_mm']!==0){
                    y_tilt_data.push(scanData[objId]['y_um_per_mm']);
                }

                if(scanData[objId]['time'] && scanData[objId]['time']['total_time'] && scanData[objId]['area']){
                    time_data.push(scanData[objId]['time']['total_time'])
                    area_data.push(scanData[objId]['area'])
                }
            }

            
        }
        let scanAnalysisData = {};
        if (this.state.isAnalysis && this.state.analysisData && this.state.showDate) {
            let dateOfScan = Object.keys(this.state.analysisData).find(key => key === date)
            scanAnalysisData = Object.keys(this.state.analysisData).find(key => key === date) && this.state.analysisData[date]['scan_analysis'];
        }

        if (this.state.isAnalysis && this.state.analysisData && this.state.analysisData["tag"] && !this.state.showDate) {
            scanAnalysisData = this.state.analysisData["tag"]['scan_analysis']
        }


        return(
            <Suspense fallback={<div>Loading...</div>}>
                <Plot
                    data={[
                        {
                            "x": x_tilt_data,
                            "type": "histogram",
                            autobinx: false,
                            xbins: {
                            size: 0.2,
                            start: 0
                        }
                    }
                    ]}
                    layout = {{
                        bargap: 0.05, 
                        bargroupgap: 0.2,
                        title: "X Tilt " + (x_tilt_data.length === 0 ? "(No Data Available)": x_tilt_data.length === 1 ? '(1 data point available)' : `(${x_tilt_data.length} data points available)`), 
                        xaxis: {title: "x_um_per_mm"}, 
                        yaxis: {title: "Count"}
                    }}
                />

                <Plot
                    data={[
                        {
                            "x": y_tilt_data,
                            "type": "histogram",
                            autobinx: false,
                            xbins: {
                            size: 0.2,
                            start: 0
                        }
                    }
                    ]}
                    layout = {{
                        bargap: 0.05, 
                        bargroupgap: 0.2,
                        title: "Y Tilt " + (y_tilt_data.length === 0 ? "(No Data Available)": y_tilt_data.length === 1 ? '(1 data point available)' : `(${y_tilt_data.length} data points available)`), 
                        xaxis: {title: "y_um_per_mm"}, 
                        yaxis: {title: "Count"}
                    }}
                />

            <Plot
                data={[
                    {
                        "x": area_data,
                        "y": time_data,
                        'name': "AreaAndTime",
                        "type": "scatter",
                        "mode": "markers+text"
                    },
                    {
                        // x: tilt, y: num_scans
                    }
            ]}
                layout={{
                    height: 540,
                    title: 'Area v/s Time ' + (area_data.length === 0 || time_data.length ===0  ? "(No Data Available)": area_data.length === 1 ? '1 data point available' : `(${area_data.length} data points available)`),
                    xaxis: {
                        title: {
                            text: 'Area',
                            font: {
                                family: 'Courier New, monospace',
                                size: 18,
                                color: '#7f7f7f'
                            }
                        }
                    },
                    yaxis: {
                        title: {
                            text: 'Time',
                            font: {
                                family: 'Courier New, monospace',
                                size: 18,
                                color: '#7f7f7f'
                            }
                        }
                    }
                }}
            />
            {this.state.isAnalysis && <Plot id={'plot'}
                                                data={this.getAnalysisPlot(scanAnalysisData)}
                                                layout={{
                                                    title: "Scan Analysis Plot " + (!scanAnalysisData || scanAnalysisData.length === 0 ? "(No Data Available)" : `(Showing ${this.state.analysisCurrentDataPoints} data point${this.state.analysisCurrentDataPoints>1?'s':''})`),
                                                    xaxis: {title: ""},
                                                    yaxis: {title: "Analysis Keys"}
                                                }}
                />}
            </Suspense>
        )
    }

    handleDropdownClose = (clickedIndex) => {
        if (this.state.openAnchor === clickedIndex)
            this.setState({openAnchor: null});
        else
            this.setState({openAnchor: clickedIndex});
    };

    getScanDataForTags = () => {
        if(this.state.selectedTags.length === 0){
            message.warn("No tags selected!")
            return
        }
        let params = "tags="
        this.state.selectedTags.map((tag) => params += tag.replace('#', '%23') + '%2c')
        let url = '/api/stats/get_tags_data/?' + params
        if(!this.state.isDataFetched && this.state.isAnalysis){
            this.getAnalysisDataForTags()
        }
        get_response(url).then(response => {
            this.setState({
                // scanData: [response?.data['tags']],
                tagsScanData : [response?.data['tags']]
            })
        }).catch(err => error_manager("Something went wrong. Contact help", err))
        
        this.setState({isDataFetched:true})
    }

    getScansData = () => {
        this.setState({isFetching: true})
        let data = {
            year: this.state.selectedYear,
            month: this.state.selectedMonth + 1,
            date: this.state.selectedDate
        }
        post('/api/stats/fetch_stats_data/', queryString.stringify(data))
            .then(response => {
                if(response['analysisScriptFailedFlag'] && response['analysisScriptFailedFlag']===true){
                    message.error("Update scripts failed [CODE:12]. Contact Support", 5)
                }
                this.setState({
                    isFetching:false,
                    scanData: response['scansData'], hourlyMachineData: response['hourlyMachine'],
                    summaryData: response['summary'], lastUpdatedData: response['lastUpdated']
                })
            })
            .catch(error => {
                error_manager("No data for the applied filters", error)
            })
        if(this.state.isAnalysis && this.state.selectedMonth === 12) {
            message.warn("Choose a month to get analysis plot")
            this.setState({
                isAnalysis:false
            })
        }
        else if(this.state.isAnalysis){
            this.getAnalysisData()
        }
        this.setState({isDataFetched: true});
    }

    reverseSizeFmt(strSize, suffix = 'B') {
        let num = 1;
        const units = ['.0', 'Ki', 'Mi', 'Gi', 'Ti', 'Pi', 'Ei', 'Zi', 'Yi'];
        for (let unit of units) {
            if (!strSize.includes(unit + suffix)) {
                num *= 1024;
            } else {
                let val = parseFloat(strSize.replace(unit + suffix, ""));
                return num * val;
            }
        }
        throw new Error("Invalid Input");
    }

    outputSizeFmt(sizeInBytes) {
        if (sizeInBytes < 1024) {
            return sizeInBytes + ' B';
        }
        const units = ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
        let size = sizeInBytes;
        let unitIndex = 0;
        size /= 1024;
        while (size >= 1024 && unitIndex < units.length - 1) {
            size /= 1024;
            unitIndex++;
        }
        return size.toFixed(2) + ' ' + units[unitIndex];
    }

    render() {
        if (!hasPermissions([aclPermissions.stats_info_menu])) {
            return getUnauthorizedComponent()
        }

        let columns = [
            {
                title: 'Date',
                dataIndex: 'Date',
                key: 'Date',
            },
            {
                title: 'Total Scans',
                dataIndex: 'totalScans',
                key: 'totalScans',
            },
            {
                title: 'Time',
                dataIndex: 'timeComponent',
                key: 'timeComponent',
            },
            {
                title: 'Size',
                dataIndex: 'sizeComponent',
                key: 'sizeComponent',
            },
            {
                title: 'Scanned Area Details',
                dataIndex: 'scannedAreaComponent',
                key: 'scannedAreaComponent',
            },
            {
                title: 'Scan Streaks',
                dataIndex: 'scanStreaksComponent',
                key: 'scanStreaksComponent',
            },
            {
                title: 'Scan Speed',
                dataIndex: 'scanSpeedComponent',
                key: 'scanSpeedComponent',
            },
            {
                title: 'Specimen Type',
                dataIndex: 'specimenTypeComponent',
                key: 'specimenTypeComponent',
            },
        ];

        const {
            scanData,
            summaryData,
            lastUpdatedData,
            openAnchor,
            isDataFetched,
            isFetching,
            hourlyMachineData,
            tagsScanData
        } = this.state;

        if(isCloud()){
            return (<div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <Typography>
                    You do not have permission to view this page.
                </Typography>
            </div>)
        }

        // let scansStat = this.getScansStatForTable();

        return (
            <div>
                <Spin spinning={this.state.isFetching}>
                    <div>
                        <Row>
                            <Col span={24} offset={0} className="all-slides">
                                <Row className="heading-style main-heading-style">
                                    <Col span={20} style={{marginTop: "10px"}}>Stats Dashboard</Col>
                                    <Col span={4}>
                                        <Radio.Group value={this.state.showDate} onChange={(event) => {this.setState({showDate: event.target.value, isDataFetched:false})}}>
                                            <Radio.Button value={true}>Date Search</Radio.Button>
                                            <Radio.Button value={false}>Tag Search</Radio.Button>
                                        </Radio.Group>
                                    </Col>
                                </Row>
                                <div>
                                    <br/>
                                    {this.state.showDate ?
                                    <Row className={"tags-section"}>
                                        <Col span={2} style={{padding: "5px 0px 0px 20px"}}>
                                            <b>{"Select Year: "}</b>
                                        </Col>
                                        <Col span={5}>
                                            <Select style={{width: 75}}
                                                    value={this.state.selectedYear}
                                                    placeholder="Select Year"
                                                    onChange={this.handleChangeYear}
                                            >
                                                {this.getYearOptions()}
                                            </Select>
                                        </Col>
                                        <Col span={2} style={{padding: "5px 0px 0px 20px"}}>
                                            <b>{"Select Month: "}</b>
                                        </Col>
                                        <Col span={5}>
                                            <Select style={{width: 75}}
                                                    value={monthMapping[this.state.selectedMonth + 1]}
                                                    placeholder="Select Month"
                                                    onChange={this.handleChangeMonth}
                                            >
                                                {this.getMonthOptions()}
                                            </Select>
                                        </Col>
                                        <Col span={2} style={{padding: "5px 0px 0px 20px"}}>
                                            <b>{"Select Date: "}</b>
                                        </Col>
                                        <Col span={4}>
                                            <Select style={{width: 75}}
                                                    value={this.state.selectedDate}
                                                    placeholder="Select Date"
                                                    onChange={this.handleChangeDate}
                                            >
                                                {this.getDateOptions()}
                                            </Select>
                                        </Col>
                                        <Col span={2} style={{padding: "5px 0px 0px 20px"}}>
                                            <b>{"Analysis Plot: "}</b>
                                        </Col>
                                        <Col span={1}>
                                            <Switch checked={this.state.isAnalysis} onChange={this.handleScanAnalysis}/>
                                        </Col>
                                    </Row>
                                    :
                                    <Row>
                                        
                                        <div className="tags-section">
                                            {this.props.allTags.map(tag => {
                                                let tagElem;
                                                tagElem = (
                                                    <Button
                                                        size="small"
                                                        onClick={() => this.addTag(tag)}
                                                        className={this.state.selectedTags.includes(tag) ?
                                                            "lighter-danger-button" :
                                                            "lighter-primary-button"}
                                                        type={this.state.selectedTags.includes(tag) ? "danger" : "primary"}
                                                        style={{margin: "2px"}}
                                                        ghost
                                                    >
                                                        {tag}
                                                    </Button>
                                                );
                                                return tagElem;
                                            })}
                                        </div>
                                        <div style={{marginTop:20}}>

                                        <Col span={2} style={{padding: "5px 0px 0px 20px"} }>
                                            <b>{"Analysis Plot: "}</b>
                                        </Col>
                                        <Col span={1}>
                                            <Switch checked={this.state.isAnalysis} onChange={this.handleScanAnalysisForTags}/>
                                        </Col>
                                        </div>
                                    </Row>
                                    }
                                    <br/>
                                    <Row>
                                        {/* <Col>
                                            <Button
                                                onClick={() => this.switchSearch()}
                                                type={"primary"}
                                                style={{"margin": "5px"}}
                                            >
                                                {this.state.showDate ? "Switch to Tag Search" : "Switch to Date Search"}
                                            </Button>
                                        </Col> */}
                                        <Col span={14}>
                                            <Button
                                                onClick={() => {this.state.showDate ? this.getScansData() : this.getScanDataForTags()}}
                                                type={"primary"}
                                                disabled={!this.state.showDate && this.state.selectedTags.length === 0}
                                                style={{margin: "5px"}}
                                            >
                                                Search
                                            </Button>
                                        </Col>
                                        {this.state.analysisKeys.length > 0 ? <Col span={10}>
                                            <Select
                                                mode="multiple"
                                                allowClear
                                                style={{width: '100%',}}
                                                placeholder="Please select Scan Analysis Keys to Plot"
                                                value={this.state.selectedKeys}
                                                defaultValue={this.state.selectedKeys}
                                                onChange={this.handleKeysChange}
                                            >
                                                {this.getKeysOptions()}
                                            </Select>
                                        </Col> : null}
                                    </Row>
                                    {/* <Row>
                                        <div className="heading-style sub-heading-style" style={{textAlign: "center"}}>
                                            <b>Displaying Results for </b>
                                            <b>{this.state.displayText}</b>
                                        </div>
                                    </Row> */}
                                    <Row>
                                    {/* <Table
                                        dataSource={scansStat}
                                        columns={columns}
                                        pagination={false}
                                        expandedRowRender={record => <div>{record.plot}</div>}
                                    /> */}
                                    <TableContainer component={Paper}>
                    <Table aria-label="collapsible table">
                        <TableHead>
                            <TableRow>
                                <TableCell/>
                                <TableCell sx={{fontWeight: 'bold'}}>Date</TableCell>
                                <TableCell sx={{fontWeight: 'bold'}}>Scans Count</TableCell>
                                <TableCell sx={{fontWeight: 'bold'}} align="right">Scan Speed</TableCell>
                                <TableCell sx={{fontWeight: 'bold'}} align="right">Specimen Type</TableCell>
                                <TableCell sx={{fontWeight: 'bold'}} align="right">Size</TableCell>
                                <TableCell sx={{fontWeight: 'bold'}} align="right">{'Area (in mm²)'}</TableCell>
                                <TableCell sx={{fontWeight: 'bold'}} align="right">Branch details</TableCell>
                                {/* <TableCell sx={{fontWeight: 'bold'}} align="right">AWS Link</TableCell> */}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {!this.state.showDate || this.state.selectedMonth + 1 !== 13 ? null :
                                summaryData[0] && summaryData[0]['month'] && this.getTotalYearlyScansInfo(summaryData)}
                            {this.state.selectedDate === 32 && this.state.showDate && Object.values(summaryData).map((summary, index) => {
                                if (!(summary && summary['month']))
                                    return
                                let sum_total_scan_time = null;
                                let unit = null;
                                try {
                                    sum_total_scan_time = Math.round((parseFloat(summary['sum_total_scan_time'].split(" ")[0]) + Number.EPSILON) * 100) / 100;
                                    unit = summary['sum_total_scan_time'].split(" ")[1]
                                } catch (e) {
                                    sum_total_scan_time = Math.round((parseFloat(summary['sum_total_scan_time'].toString()) + Number.EPSILON) * 100) / 100;
                                    unit = "Minutes";
                                }
                                return <>
                                    <TableRow key={summary['month']}
                                              sx={{":hover": {backgroundColor: 'rgb(203, 195, 227, 0.4)'}}}>
                                        <TableCell>
                                            <IconButton
                                                aria-label="expand row" size="small"
                                                onClick={() => this.handleDropdownClose(index - 1)}>
                                                {openAnchor === index - 1 ? <KeyboardArrowUpIcon/> :
                                                    <KeyboardArrowDownIcon/>}
                                            </IconButton>
                                        </TableCell>
                                        <TableCell component="th" scope="row"><strong>Total: </strong>{summary['month']}
                                        </TableCell>
                                        <TableCell>{this.getScanCount(summary['summarized_scan_count'])}</TableCell>
                                        <TableCell
                                            align="right">{this.getScanSpeed(summary['summarized_scan_speed'])}</TableCell>
                                        
                                        <TableCell
                                            align="right">{this.getSpecimenType(summary['summarized_specimen_type'])}</TableCell>
                                        <TableCell
                                            align="right">{this.getScanSize(summary['size'])}</TableCell>
                                        <TableCell
                                            align="right">{this.getScanAreaSumm(summary['summarized_area'])}</TableCell>
                                        <TableCell align="right">
                                            <strong>Average Scan Time:</strong><br/>
                                            {this.getAverageScanTime(summary['sum_total_scan_time'], summary['summarized_scan_count']['success'])}<br/>
                                            <strong>Total Scan Time:</strong>
                                            {`${sum_total_scan_time} ${unit}`}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={10}>
                                            <Collapse in={openAnchor === index - 1} timeout="auto" unmountOnExit>
                                                <Box sx={{margin: 1}}>
                                                    <Typography variant="h6" gutterBottom component="div">
                                                        Summary Info
                                                    </Typography>
                                                    <Table size="small" aria-label="purchases">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>Scans Count Date-Wise</TableCell>
                                                                <TableCell align="left">Last Updated</TableCell>
                                                                <TableCell align="left">Plot</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {this.getSummaryInfo(summary)}
                                                        </TableBody>
                                                    </Table>
                                                </Box>
                                            </Collapse>
                                        </TableCell>
                                    </TableRow>
                                </>
                            })}
                            {this.state.selectedMonth + 1 !== 13 && scanData.length === 0 ?
                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={"No Data"}/> :
                                Object.entries(this.state.showDate ? scanData : tagsScanData).map(([key, value], index) => {
                                    let date_lenth = this.state.selectedDate.toString().length
                                    let dateCondition = true;
                                    if(this.state.showDate && value['date']){
                                        dateCondition = date_lenth === 2 ? this.state.selectedDate.toString() === value['date'].slice(-2): ("0" + this.state.selectedDate.toString()).toString() == value['date'].slice(-2) 
                                    }
                                    
                                    return (
                                        value && value['summarized_data'] && (this.state.selectedTags.length>0 || this.state.selectedDate === 32 || dateCondition) && value['summarized_data']['summarized_scan_count'] && <>
                                            <TableRow key={value['date']}
                                                      sx={{":hover": {backgroundColor: 'rgb(203, 195, 227, 0.4)'}}}>
                                                <TableCell>
                                                    <IconButton
                                                        aria-label="expand row" size="small"
                                                        onClick={() => this.handleDropdownClose(index)}>
                                                        {openAnchor === index ? <KeyboardArrowUpIcon/> :
                                                            <KeyboardArrowDownIcon/>}
                                                    </IconButton>
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {value['date']}
                                                </TableCell>
                                                <TableCell>{this.getScanCount(value['summarized_data']['summarized_scan_count'])}</TableCell>
                                                <TableCell
                                                    align="right">{this.getScanSpeed(value['summarized_data']['summarized_scan_speed'])}</TableCell>
                                                <TableCell
                                                    align="right">{this.getSpecimenType(value['summarized_data']['summarized_specimen_type'])}</TableCell>
                                                <TableCell
                                                    align="right">{this.getScanSize(value['summarized_data']['size'])}</TableCell>
                                                <TableCell
                                                    align="right">{this.getScanAreaSumm(value['summarized_data']['summarized_area'])}</TableCell>
                                                <TableCell
                                                    align="right">{this.getOtherDetails(value['scano_branch'], value['morpheus_branch'])}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={10}>
                                                    <Collapse in={openAnchor === index} timeout="auto" unmountOnExit>
                                                        <Box sx={{margin: 1}}>
                                                            {openAnchor === index && this.getPlots(value['scans_data'], value['date'])}
                                                            <Typography variant="h6" gutterBottom component="div">
                                                                Scans Info
                                                            </Typography>
                                                            <DataGrid
                                                                initialState={{}}
                                                                disableRowSelectionOnClick
                                                                autoHeight
                                                                columns={sortableHeaders}
                                                                rows={this.getScanInfo(value['scans_data'])}
                                                                getRowHeight={() => 'auto'}
                                                            />
                                                        </Box>
                                                    </Collapse>
                                                </TableCell>
                                            </TableRow>
                                        </>
                                    )
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Spin>
            </div>
        );
    }

    addTag(tag) {
        let tags = this.state.selectedTags
        const index = tags.indexOf(tag)
        if (index!==-1){
            tags.splice(index, 1)
        }
        else{
            tags.push(tag)
        }
        this.setState({
            selectedTags: tags
        })
    }
}

const mapStateToProps = state => {
    return {
        allTags: state.dashboardReducer.allTags
    };
};

export default connect(mapStateToProps)(StatsDashboard);